import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import React from 'react';

const LoaderWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  minHeight: '80vh', 
});

const StyledCircularProgress = styled(CircularProgress)({
  color: '#a7a9aa',
  width: 100,
  height: 100,
});

interface CircularIndeterminateProps {
  size?: number; // optional, default 100
  thickness?: number; // optional, default 4
}

export const CircularIndeterminate: React.FC<CircularIndeterminateProps> = ({
  size = 100,
  thickness = 4,
}) => {
  return (
    <LoaderWrapper className='loader'>
      <StyledCircularProgress size={size} thickness={thickness} />
    </LoaderWrapper>
  );
};

CircularIndeterminate.displayName = 'CircularIndeterminate';

export default CircularIndeterminate;
